<template>
  <div class="license-roundedbox-wrap">
    <div class="roundedbox">
      <div class="roundedbox-top">
        <div style="display: flex; height:55px;">
          <img :src='data.thumbUrl' alt="">
          <div>
            <div class="top-row">
              <h5 class="roundedbox-title">{{data.lcsnNm}}</h5>
            </div>
            <div class="roundedbox-bottom" style="align-items: center;" >
              <div  class="badge" v-if="data.lcsnCd !='ETC'" >
                <span class="badge-text" v-if="data.examDate <= 0 ">D{{data.examDate}}</span>
              </div>

              <div v-if="data.socLcsnRegYn == 'Y' " class="badge badge-red" style="margin-left:5px" ><span class="badge-text" >진행중</span></div>
              <div  v-if="data.socLcsnGetYn == 'Y' " class="badge badge-primary" style="margin-left:5px" ><span class="badge-text" >달성</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="roundedbox-bottom" id="mouse-over" >
        <div class="license-button" style="cursor: pointer" >

          <span class="left" v-if="!isMobile" style="color:#111;">{{data.socLcsnRegAllCnt}}명 도전중</span>
          <span class="left" v-else @click="doSearch(data.lcsnNm)" style="color:#111;">{{data.socLcsnRegAllCnt}}명 도전중
          <p class="text-muted text-decoration-underline">노트 모아보기</p></span>
          <span class="center" v-if="!isMobile" @click="doSearch(data.lcsnNm)">학습노트 모아보기</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {computed} from "vue";
import {useStore} from "vuex";

export default {
  name: 'SSLLicStatusCard',
  components: {},
  props: {
    data: Object,
    modelValue: Boolean,
  },
  emits: ['update:modelValue', 'search'],
  setup( props,{emit}) {
    // const item = computed(() => props.data);

    const store = useStore();
    const isMobile = computed(() => store.state.auth.isMobile);
    const doSearch = (lcsnNm)=>{
      emit('search',lcsnNm);
    }
    return {
      isMobile,
      doSearch
    }
  }
}
</script>
